import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { cloneElement, Component } from 'react';
import { isNullOrUndefinedOrEmpty } from '../../../../helpers/common';
import { propArrayShape, propChildren, propNumber, propStr, } from '../../../../helpers/custom-prop-types';
import AboutAccordion from './AboutAccordion';
class AboutRowListWrapper extends Component {
    constructor() {
        super(...arguments);
        this.renderComponent = () => {
            const { children, className, maxCount, minCount, rows, wrapComponent: WrapComponent, } = this.props;
            return (_jsx(WrapComponent, Object.assign({ className: className }, { children: rows.map((record, index) => {
                    if (minCount !== undefined && minCount > index) {
                        return null;
                    }
                    if (maxCount !== undefined && maxCount <= index) {
                        return null;
                    }
                    return cloneElement(children, { key: record.id, record });
                }) })));
        };
    }
    render() {
        const { buttonClassName, minCount, name, rows } = this.props;
        if (!isNullOrUndefinedOrEmpty(minCount)) {
            return minCount < rows.length ? (_jsx(AboutAccordion, Object.assign({ buttonClassName: buttonClassName, keyId: `accordion-${name}`, openText: 'View More' }, { children: this.renderComponent() }))) : null;
        }
        return this.renderComponent();
    }
}
AboutRowListWrapper.propTypes = {
    buttonClassName: propStr(),
    children: propChildren().isRequired,
    className: propStr().isRequired,
    maxCount: propNumber(),
    minCount: propNumber(),
    name: propStr().isRequired,
    rows: propArrayShape().isRequired,
    wrapComponent: propStr(),
};
AboutRowListWrapper.defaultProps = {
    buttonClassName: '',
    maxCount: undefined,
    minCount: undefined,
    wrapComponent: 'div',
};
export default AboutRowListWrapper;
